import { pathKey } from './path';

/** People / org / team domain query segments */
export const PeopleQueryKeys = {
  users: {
    searchAll: ['users/search'] as const,
    search: (params: unknown) => ['users/search', params] as const,
    detail: (uid: string) => [`users/${uid}`] as const,
    pathDetail: (uid: string) => pathKey(`users/${uid}`),
    filterValues: ['user-filter-values'] as const,
    prefetch: (selectedUserUid: string) => ['get-user-on-page-load', { selectedUserUid }] as const,
    prefetchMultiple: (selectedUserUid: string) => ['get-user-on-page-load', { selectedUserUid }] as const,
    searchPost: (payload: unknown) => [{ path: 'users/search', payload }] as const,
  },
  teams: {
    search: (search: unknown) => [`teams/search`, search] as const,
    detail: (teamUid: string) => [`teams/${teamUid}`] as const,
    searchPost: (payload: unknown) => [{ path: 'teams/search', payload }] as const,
    prefetch: (selectedTeamUid: string) => ['get-team-on-page-load', { selectedTeamUid }] as const,
  },
  orgs: {
    detail: (uid: string) => pathKey(`orgs/${uid}`),
    filterValues: {
      all: ['org-filter-values'] as const,
    },
    searchAll: [`orgs/search`] as const,
    search: (search: unknown) => [`orgs/search`, search] as const,
    searchPost: (payload: unknown) => [{ path: 'orgs/search', payload }] as const,
    extMetadata: (orgTypeSlug: string) => [`org-ext-metadata/${orgTypeSlug}`] as const,
  },
  people: {
    search: (params: { search: { freeText: string } }) => [`people/search`, params] as const,
  },
  roles: {
    extMetadata: (roleSlug: string) => [`role-ext-metadata/${roleSlug}`] as const,
  },
  policyCheck: {
    all: ['policy-check'] as const,
  },
  scopeSearch: (scope: string, payload: unknown) => [scope, payload] as const,
};
